import React, { useState } from 'react'
import { ActionIcon, Button, useMantineTheme } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { ClockIcon } from '@radix-ui/react-icons'

import { useAvailabilityOwner } from './useAvailabilityOwner'
import { WeeklyAvailabilityModal } from './WeeklyAvailabilityModal'
import { getWeekStart } from './weekUtils'

import { useCalendarParams } from '@/queries/useCalendarParams'
import { useWeeklyAvailabilityQuery } from '@/queries/weeklyAvailability'

export const AvailabilityHeaderAction: React.FC = () => {
  const availabilityOwner = useAvailabilityOwner()
  const calendarParams = useCalendarParams()
  const [isOpen, setIsOpen] = useState(false)
  const { breakpoints } = useMantineTheme()
  const isCompact = useMediaQuery(`(max-width: ${breakpoints.sm})`)

  const weekStart = calendarParams ? getWeekStart(calendarParams.date) : null

  const { data: response } = useWeeklyAvailabilityQuery(
    availabilityOwner?.owner ?? null,
    weekStart ?? new Date(),
    { enabled: !!weekStart && calendarParams?.view === 'week' },
  )

  if (!availabilityOwner || !weekStart || calendarParams?.view !== 'week') {
    return null
  }

  const isReadOnly = response?.data.is_read_only ?? false

  return (
    <>
      {isCompact ? (
        <span
          className={isReadOnly ? 'inline-flex cursor-not-allowed' : undefined}
        >
          <ActionIcon
            variant="default"
            aria-label="Edit available hours"
            disabled={isReadOnly}
            onClick={() => setIsOpen(true)}
          >
            <ClockIcon />
          </ActionIcon>
        </span>
      ) : (
        <span
          className={isReadOnly ? 'inline-flex cursor-not-allowed' : undefined}
        >
          <Button
            variant="default"
            size="xs"
            leftIcon={<ClockIcon />}
            disabled={isReadOnly}
            onClick={() => setIsOpen(true)}
          >
            Edit available hours
          </Button>
        </span>
      )}
      {isOpen && !isReadOnly && (
        <WeeklyAvailabilityModal
          owner={availabilityOwner.owner}
          defaultTimezone={availabilityOwner.defaultTimezone}
          initialWeekStart={weekStart}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  )
}
